import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { format } from 'date-fns';

interface EmspBoTariffCreatedAfterFilterStateControllerProps {
  value: Date | string;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoTariffCreatedAfterFilterStateController = ({
  value,
  onRemove,
}: EmspBoTariffCreatedAfterFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const createdAt = format(value, 'yyyy-MM-dd');

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem icon="calendar-date" label={createdAt} onRemove={onRemove} />
  );
};
